export * from './components/Fabric/index';
//# sourceMappingURL=Fabric.js.map